import {IFrameElement} from "./IFrameElement";
import {IFrameMessages} from "../../messaging/IFrameMessages";
import {
    IS_PRODUCTION,
    TEST_MODE,
    WALL_TRANSITION, GATE_TYPE, IFRAME_APP_TYPE, POPUP_GATE_TRANSITION_TIME,
} from "../../Constants";
import {delayThrottled} from "../../utils/Utils";
import {userDataModule} from "../../modules/UserDataModule";
import {Dispatcher} from "../../../stem-core/src/base/Dispatcher";
import {purchaseModule} from "../../modules/PurchaseModule";


export class PanelElement extends IFrameElement {
    flowCheckpoint = new Dispatcher();
    flowFinish = new Dispatcher();
    flowSuccess = new Dispatcher();
    sizeChange = new Dispatcher();

    height = null;
    width = null;

    constructor(...args) {
        super(...args);
        if (!IS_PRODUCTION || TEST_MODE) {
            this.node.setAttribute("route", this.options.type);
            this.node.setAttribute("panel-type", this.options.type);
            this.node.setAttribute("gate-type", this.options.gateType);
            this.node.setAttribute("expanded", false);
        }
    }

    // TODO @Mihai why all the getters?
    get appType() {
        return IFRAME_APP_TYPE.panel;
    }

    // For backwards compatibility reasons, panels that prompt purchases may get
    // their payment details from the "requestPayment" from the PurchaseModule if
    // they didn't receive them as options.
    get paymentDetails() {
        return this.options.paymentDetails || purchaseModule.lastPaymentRequestData;
    }

    get paymentRequestStatus() {
        const {paymentDetails} = this;
        return purchaseModule.paymentRequests.get(paymentDetails && paymentDetails.offerId);
    }

    getIFrameParams() {
        return {
            ...super.getIFrameParams(),
            paymentDetails: this.paymentDetails,
            paymentRequestStatus: this.paymentRequestStatus,
        };
    }

    isFlowSuccess() {
        return false;
    }

    getFlowFinishResult() {
        return {};
    }

    checkFlowSuccess() {
        if (this.isFlowSuccess()) {
            this.flowSuccess.dispatch();
        }
    }

    refreshStyle() {
        super.refreshStyle();
        this.setStyle({
            visibility: "visible",
        });
        // TODO @branch what if we only set only one of width or height
        if (this.height && this.width && this.options.gateType !== GATE_TYPE.popup) {
            this.setStyle({
                height: this.height + "px",
                width: this.width + "px",
                transition: WALL_TRANSITION,
            });
        }
    }

    destroyNode() {
        this.flowFinish.dispatch(this.getFlowFinishResult());
        return super.destroyNode();
    }

    onMount() {
        super.onMount();

        this.addSdkListener(IFrameMessages.UPDATE_PANEL_SIZE, ({height, width}) => {
            if (height < 50) {
                // TODO @cleanup why the hell is 50 the magic number here?
                return;
            }
            this.height = height;
            this.width = width;
            this.refreshStyle();
            this.sizeChange.dispatch({height, width});
            if (!IS_PRODUCTION || TEST_MODE) {
                this.attachTimeout(() => this.node.setAttribute("expanded", "true"), POPUP_GATE_TRANSITION_TIME);
            }
        });

        // There are cases when the panel size is not calculated correctly while the user is scrolling
        // TODO @branch @bug this is definetly wrong, the 100 is outside delayThrottled
        this.attachEventListener(window, "resize", delayThrottled(
            () => this.sendMessage(IFrameMessages.REQUEST_UPDATE_PANEL_SIZE)), 100);

        // In some browsers, we need to recalculate the panel size when the current tab becomes active
        // Otherwise, there is a risk for the panel element to be invisible or to have an odd height/width
        this.attachEventListener(document, "visibilitychange", () => {
            if (document.visibilityState === "visible") {
                this.sendMessage(IFrameMessages.REQUEST_UPDATE_PANEL_SIZE);
            }
        });

        this.addSdkListener(IFrameMessages.SCROLL_IFRAME_TOP, () => this.node?.scrollIntoView({behavior: "smooth"}));
        this.addSdkListener(IFrameMessages.FLOW_CHECKPOINT, ({event}) => this.flowCheckpoint.dispatch(event));

        this.attachListener(purchaseModule.paymentRequestReceived, () => this.resendIFrameParams());
        this.attachListener(purchaseModule.paymentRequestCompleted, () => this.resendIFrameParams());

        if (!IS_PRODUCTION || TEST_MODE) {
            this.addSdkListener(IFrameMessages.ROUTE_CHANGE, ({route}) => {
                this.node.setAttribute("route", route);
            });
        }

        // Common cases when the "flow success" state might change.
        this.checkFlowSuccess();
        this.attachListener(userDataModule.userPreferencesChange, () => this.checkFlowSuccess());
        this.attachListener(purchaseModule.paymentRequestCompleted, () => this.checkFlowSuccess());
    }
}
